"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var COLLABORATOR_INFO_POPOVER_KEY = "qwilr-collaborator-info-popover";
var HELP_DOC_URL = "https://help.qwilr.com/article/749-new-sharing-security-settings-summer-2022#collab";
var c = (0, BemBuilder_1.default)("collaborator-info-popover");
var CollaboratorPageInfoPopover = function () {
    var _a = __read((0, react_1.useState)(false), 2), popoverOpen = _a[0], setPopoverOpen = _a[1];
    var closePopover = (0, react_1.useCallback)(function () { return setPopoverOpen(false); }, []);
    var onEscKeyDown = (0, react_1.useCallback)(function (event) {
        if (event.key !== kaleidoscope_1.KeyType.Escape)
            return;
        closePopover();
    }, []);
    var onClickOutside = (0, react_1.useMemo)(function () { return new utils_1.OnClickOutside(["#popover-root", ".collaborator-info-popover__info-button"], closePopover); }, []);
    var startListenings = (0, react_1.useCallback)(function () {
        onClickOutside.startListening();
        window.addEventListener("keydown", onEscKeyDown);
    }, []);
    var stopListenings = (0, react_1.useCallback)(function () {
        onClickOutside.stopListening();
        window.removeEventListener("keydown", onEscKeyDown);
    }, []);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        var showInfoPopover = !((_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem(COLLABORATOR_INFO_POPOVER_KEY));
        if (showInfoPopover) {
            setTimeout(function () { return setPopoverOpen(true); }, 1000);
            (_b = window.localStorage) === null || _b === void 0 ? void 0 : _b.setItem(COLLABORATOR_INFO_POPOVER_KEY, "true");
        }
    }, []);
    (0, react_1.useEffect)(function () {
        if (popoverOpen)
            startListenings();
        else
            stopListenings();
        return stopListenings;
    }, [popoverOpen]);
    return (react_1.default.createElement(kaleidoscope_1.Popover, { caret: true, isOpen: popoverOpen, theme: kaleidoscope_1.PopoverTheme.Light, size: kaleidoscope_1.PopoverSize.Large, className: c(), offset: 16, button: function (_a) {
            var onClick = _a.onClick, buttonProps = __rest(_a, ["onClick"]);
            return (react_1.default.createElement(kaleidoscope_1.IconButton, __assign({ size: kaleidoscope_1.ButtonSize.XSmall, theme: kaleidoscope_1.ButtonTheme.Dark, icon: react_1.default.createElement(icons_1.InformationCircle, { size: icons_1.IconSize.Small }), "aria-label": "More info", onClick: function () { return setPopoverOpen(!popoverOpen); }, className: c("info-button") }, buttonProps)));
        } },
        react_1.default.createElement(kaleidoscope_1.IconButton, { className: c("close-button"), onClick: closePopover, size: kaleidoscope_1.ButtonSize.Small, icon: react_1.default.createElement(icons_1.Close, null), "aria-label": "close" }),
        react_1.default.createElement("img", { className: c("image"), src: "/Public/Assets/Images/collaborator-preview.png" }),
        react_1.default.createElement("div", { className: c("heading") },
            react_1.default.createElement(icons_1.Team, { size: icons_1.IconSize.Medium }),
            react_1.default.createElement("span", { className: "text-h5 collaborator-info-popover__heading-text" }, "Collaborator Preview")),
        react_1.default.createElement("div", { className: "text-context-label collaborator-info-popover__label" }, "For internal collaboration only"),
        react_1.default.createElement("div", { className: "text-description collaborator-info-popover__description" },
            "You're viewing the collaborator preview for this Qwilr page. This page is for sharing internally for feedback. Anyone with the link can view, and views do not count towards analytics.",
            " ",
            react_1.default.createElement("strong", null, "Avoid sharing this page externally"),
            "."),
        react_1.default.createElement("div", { className: "collaborator-info-popover__buttons" },
            react_1.default.createElement(kaleidoscope_1.Button, { href: function () { return HELP_DOC_URL; }, size: kaleidoscope_1.ButtonSize.Medium, type: kaleidoscope_1.ButtonType.Secondary }, "Learn More"),
            react_1.default.createElement(kaleidoscope_1.Button, { size: kaleidoscope_1.ButtonSize.Medium, type: kaleidoscope_1.ButtonType.Primary, onClick: closePopover },
                react_1.default.createElement(icons_1.ThumbsUp, null),
                " Got it"))));
};
exports.default = CollaboratorPageInfoPopover;
